export default __webpack_public_path__ + "static/media/register-as-retailer-on-vegshelf.4ed20014.png";